import { render, staticRenderFns } from "./MultipleFileUploader.vue?vue&type=template&id=07afc557&scoped=true&"
import script from "./MultipleFileUploader.vue?vue&type=script&lang=ts&"
export * from "./MultipleFileUploader.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleFileUploader.vue?vue&type=style&index=0&id=07afc557&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07afc557",
  null
  
)

export default component.exports